import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    testEngagmentListLoading: false,
    testEngagmentListSuccess: {},
    testEngagmentListError: "",

    downloadTestengagmentLoading: false,
    downloadTestengagmentSuccess: {},
    downloadTestengagmentError: "",

}


export const testEngagmentTypeSlice = createSlice({
    name: 'test-engagment',
    initialState,
    reducers: {
        setTestengagmentLoading: (state, action) => {
            state.testEngagmentListLoading = true;
            state.testEngagmentListSuccess = {};
            state.testEngagmentListError = "";

        },

        setTestengagmentSuccess: (state, action) => {
            state.testEngagmentListLoading = false;
            state.testEngagmentListSuccess = action.payload;
            state.testEngagmentListError = "";
        },
        setTestengagmentError: (state, action) => {
            state.testEngagmentListLoading = false;
            state.testEngagmentListSuccess = {}
            state.testEngagmentListError = action.payload.message
        },
        setDownloadTestengagmentLoading: (state, action) => {
            state.downloadTestengagmentLoading = true
            state.downloadTestengagmentSuccess = {}
            state.downloadTestengagmentError = ""

        },
        setDownloadTestengagmentSuccess: (state, action) => {
            state.downloadTestengagmentLoading = false
            state.downloadTestengagmentSuccess = action.payload
            state.downloadTestengagmentError = ""

        },
        setDownloadTestengagmentError: (state, action) => {
            state.downloadTestengagmentLoading = false
            state.downloadTestengagmentSuccess = {}
            state.downloadTestengagmentError = action.payload.message
        },

    },
})

// Action creators are generated for each case reducer function
export const { setTestengagmentLoading, setTestengagmentSuccess,setTestengagmentError,setDownloadTestengagmentLoading,setDownloadTestengagmentSuccess,setDownloadTestengagmentError
} = testEngagmentTypeSlice.actions

export default testEngagmentTypeSlice.reducer;